import React from 'react';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { theme as deeptrueTheme } from '@deeptrue-frontend/ui';
import { ThemeProvider as StyledThemeProvider } from 'styled-components/macro';

interface ThemeProviderProps {
  children: React.ReactNode;
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#0055ab',
    },
    secondary: {
      main: '#0055ab',
    },
    action: {
      disabled: '#0055ab',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.87)',
      disabled: 'rgba(0, 0, 0, 0.87)',
    },
  },
  typography: {
    fontFamily: 'Inter, Helvetica',
  },
  overrides: {
    MuiOutlinedInput: {
      input: {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
      },
      root: {
        border: 'none',
        borderRadius: '2px',
        minHeight: '50px',

        '&:hover': {
          boxShadow: '0 5px 10px 0 rgba(53,53,49,0.1)',
        },
      },
    },
  },
});

const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <MuiThemeProvider theme={theme}>
    <StyledThemeProvider theme={deeptrueTheme}>{children}</StyledThemeProvider>
  </MuiThemeProvider>
);

export default ThemeProvider;
